import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import withCurrentUser from 'dpl/decorators/withCurrentUser';
import UserLoginButton from 'dpl/UserAuth/components/UserLoginButton';

/** @param {Record<string, any>} props */
function UserLoginButtonContainer({ isLoggedIn = null, ...rest }) {
  const props = { isLoggedIn, ...rest };
  if (isLoggedIn === false) {
    return <UserLoginButton showSignupText={false} {...props} />;
  }

  return null;
}

UserLoginButtonContainer.propTypes = {
  isLoggedIn: PropTypes.bool
};

export default compose(withCurrentUser)(UserLoginButtonContainer);
